export default from "./component";
